import React, { MouseEvent } from 'react';

interface Props {
  className?: string;
  onClick?: (event: MouseEvent<Element>) => void;
}

/**
 * ViewInArIcon - Material Design view_in_ar icon
 * Used for Virtual Tour badges
 */
const ViewInArIcon = ({ className, onClick }: Props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" className={className} onClick={onClick}>
      <path fill="currentColor" d="M3 4c0-.55.45-1 1-1h2V1H4C2.34 1 1 2.34 1 4v2h2V4zm16-1c.55 0 1 .45 1 1v2h2V4c0-1.66-1.34-3-3-3h-2v2h2zM3 20v-2H1v2c0 1.66 1.34 3 3 3h2v-2H4c-.55 0-1-.45-1-1zm17 0c0 .55-.45 1-1 1h-2v2h2c1.66 0 3-1.34 3-3v-2h-2v2zM12 7.5 9 9.27v3.46l3 1.73 3-1.73V9.27L12 7.5zM12 2 6.5 5.5v7L12 16l5.5-3.5v-7L12 2zm3.5 9.5L12 13.73 8.5 11.5V8.27L12 6.04l3.5 2.23v3.23z"/>
    </svg>
  );
};

export default ViewInArIcon;
